// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-decoration {\n  text-decoration: none;\n}\n.important-links {\n  background-color: #ee2a7b;\n  font-size: 14px;\n}\n.important-links h4 {\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
